import type { LayerState } from '@vitals/shared';

export type ChangeListener = (layerId: string) => void;

export class ClientStore {
  private states = new Map<string, LayerState>();
  private listeners = new Set<ChangeListener>();

  apply(state: LayerState): void {
    this.states.set(state.layerId, state);
    for (const cb of this.listeners) cb(state.layerId);
  }
  get(layerId: string): LayerState | undefined {
    return this.states.get(layerId);
  }
  onChange(cb: ChangeListener): () => void {
    this.listeners.add(cb);
    return () => this.listeners.delete(cb);
  }
}
